import { render, staticRenderFns } from "./ApplicationFormSchoolPicker.vue?vue&type=template&id=013a460a&"
import script from "./ApplicationFormSchoolPicker.vue?vue&type=script&lang=js&"
export * from "./ApplicationFormSchoolPicker.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFormSchoolPicker.vue?vue&type=style&index=0&id=013a460a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports